import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Subscribe to / unsubscribe from a message's reply-thread notifications — the
 * per-message "Notifications" toggle. The server FLIPS the message id in the
 * current member's `notificationSettings.subscribedToUpdatesOfMessages` (no
 * explicit on/off — an empty body toggles), so the live membership subscription
 * (`useMyChannelMembership`) reflects the new state; no optimistic write here.
 */
export async function toggleMessageSubscription({
  creatorId,
  channelId,
  messageId,
}: {
  creatorId: string;
  channelId: string;
  messageId: string;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerToggleCommunityChannelMessageSubscription(
    {
      sellerId: creatorId,
      channelId,
      messageId,
      body: {},
    },
  );
}
